import { deepmerge } from '@utils/deepmerge';

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    maintainAspectRatio: false,
    plugins: {
      datalabels: false,
      legend: { position: 'bottom' },
    },
    interaction: {
      axis: 'y',
      intersect: false,
      mode: 'nearest'
    },
    y: {
      grid: {
        display: false,
      }
    },
    x: {
      grid: {
        display: false,
      },
      display: true,
      border: {
        display: true
      },
    }
  }, options);
}
